import React from 'react';

import { Box, Chip, Typography, alpha } from '@mui/material';

import { actionColour, actionText } from './palette';
import { CommandFlag } from './types';

export default function ActionDefinitions() {
  return (
    <Box
      aria-label="Action definitions"
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }, gap: 1, my: 2 }}
    >
      <Typography variant="caption" fontWeight={700} sx={{ gridColumn: '1 / -1' }}>
        All actions and counts are per departure.
      </Typography>
      {[
        [
          'red',
          'Needs Action',
          'Median predicted margin below 5%, with Medium or High confidence.',
        ],
        ['amber', 'Watch', 'Median predicted margin 5–10%, or a Needs Action risk with Low or Indicative confidence.'],
        ['green', 'On Track', 'Median predicted margin 10% or more.'],
        ['empty', 'No Bookings', 'On sale, no bookings, handback within 120 days.'],
        ['early', 'No Bookings Yet', 'On sale, no bookings, handback more than 120 days away.'],
        ['handed back', 'Past Handback', 'Final booked numbers; no departure action.'],
      ].map(([flag, label, description]) => (
        <Typography key={label} variant="caption">
          <Chip
            data-definition-pill
            size="small"
            label={label}
            sx={{
              color: actionText(flag as CommandFlag),
              bgcolor: alpha(actionColour(flag as CommandFlag), 0.14),
              fontSize: 11,
              fontWeight: 700,
              mr: 0.5,
              mb: 0.5,
            }}
          />{' '}
          {description}
        </Typography>
      ))}
    </Box>
  );
}
